import { createAsyncThunk } from '@reduxjs/toolkit';
import { devicesApi } from 'services/devices/devices.api';
import { rejectServerError } from './thunkErrors.utils';

// Fetch the device type map used for device categorization.
export const fetchDeviceTypeMap = createAsyncThunk(
  'integration/fetchDeviceTypeMap',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const resultAction = await dispatch(devicesApi.endpoints.getDeviceTypeMap.initiate());
      if ('error' in resultAction) return rejectServerError(rejectWithValue);
      return resultAction.data;
    } catch (err) {
      return rejectServerError(rejectWithValue);
    }
  },
);
